/* eslint-disable camelcase */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
// import LazyLoad from 'react-lazyload';

import { ChoiceFieldLabel, OptionWrappper, ImageWrapper, Input, Img, ImageContainer } from '../../common-field-styles';
import { FormContext } from '../../../shared/contexts/form-context';
import { ControlPropType } from '../../ctrl_proptype';

const imageSizeClass = {
  small: 'sm',
  medium: 'md',
  large: 'lg',
};

const ImageChoiceOption = (props) => {
  const { ctrl, option, optionIndex, handleChange, formDesign } = props;
  const { inBuilder, inCustomise } = useContext(FormContext);

  const imageUrl = ctrl.props.images[optionIndex] ? ctrl.props.images[optionIndex] : ctrl.props.image_url;
  const size = imageSizeClass[ctrl.props.image_size];

  return (
    <OptionWrappper className={`${size} choice-label`}>
      {ctrl.props.show_labels && (
        <ChoiceFieldLabel
          htmlFor={`fpl-${ctrl.internal_id}-${optionIndex}`}
          className={formDesign?.design.form_direction === 'rtl' ? 'rtl' : ''}
          notInBuilder={!inBuilder}>
          {option}
        </ChoiceFieldLabel>
      )}
      <ImageWrapper htmlFor={`fpl-${ctrl.internal_id}-${optionIndex}`}>
        <Input
          type={ctrl.props.rating_type}
          required={ctrl.props.required}
          onChange={(e) => {
            handleChange(e, option);
          }}
          value={option}
          disabled={ctrl.props.readonly || inCustomise || inBuilder}
          name={`fpl-${ctrl.internal_id}-${optionIndex}`}
          id={`fpl-${ctrl.internal_id}-${optionIndex}`}
          checked={ctrl.props.rating_type === 'checkbox' ? !!ctrl.value?.includes(option) : option === ctrl.value}
        />
        <ImageContainer imgChoice>
          {/* <LazyLoad height={150} className="animate-lazyloader"> */}
          <Img src={imageUrl} alt={option} />
          {/* </LazyLoad> */}
        </ImageContainer>
      </ImageWrapper>
    </OptionWrappper>
  );
};

ImageChoiceOption.defaultProps = {
  formDesign: null,
};

ImageChoiceOption.propTypes = {
  ctrl: PropTypes.shape(ControlPropType).isRequired,
  option: PropTypes.string.isRequired,
  optionIndex: PropTypes.number.isRequired,
  handleChange: PropTypes.func.isRequired,
  formDesign: PropTypes.shape({
    old: PropTypes.object.isRequired,
    design: PropTypes.object.isRequired,
  }),
};
export default ImageChoiceOption;
